import React from 'react';
import CustomerDataSection from './CustomerDataSection';

const recordTypes = [
    { key: 'user_accounts', label: 'User Accounts', icon: 'bi-people' },
    { key: 'teams', label: 'Teams', icon: 'bi-people-fill' },
    { key: 'storage_sites', label: 'Storage Sites', icon: 'bi-geo-alt' },
];

const AuditTrailMasterData = () => (
    <CustomerDataSection
        title="Audit Trail - Master Data"
        titleIcon="bi-diagram-3"
        recordTypesLabel="Master Data Record Types"
        recordTypes={recordTypes}
    />
);

export default AuditTrailMasterData;
